import { Component, OnInit, ElementRef } from '@angular/core';
import { getOTPForCustomerProposalAcceptanceModel, validateOTPForCustomerProposalAcceptanceModel, RejectProposal } from 'src/app/core/models/customerProposalDetails';
import { NewProposalService } from 'src/app/core/services/new-proposal.service';
import { CommonService } from 'src/app/core/services/common-service';
import { DatePipe, formatDate } from '@angular/common';
import { NewQuoteService } from 'src/app/core/services/new-quote.service';
import { ActivatedRoute, Router } from '@angular/router';
import { PaymentPendingService } from 'src/app/core/services/payment-pending.service';
import { NotificationService } from 'src/app/core/services/notification.service';
import { CreateQuoteService } from 'src/app/core/services/create-quote-service';
import { CommonMethodService } from 'src/app/core/services/common.method-service';
import { customerProposalService } from 'src/app/core/services/customerProposal.service.';
import { updateProposalToPolicyModel } from 'src/app/core/models/updateProposalToPolicy';
import product_related from 'src/assets/FAQs/marinestop-customer_faqs/product_related.json';
import general from 'src/assets/FAQs/marinestop-customer_faqs/general.json';
import { HttpErrorResponse } from '@angular/common/http';
import { BasisOfValuation, CommodityDetail, CommodityRiskDetails, DeductibleDetails, RiskDetailsMarineOpen } from 'src/app/core/models/marineStopProposal';

declare var $: any;

@Component({
    selector: 'app-ms-customer-proposal',
    templateUrl: './ms-customer-proposal.component.html',
    styleUrls: ['./ms-customer-proposal.component.css'],
    standalone: false
})
export class MsCustomerProposalComponent implements OnInit {
  setRotate0: boolean = false;
  setRotate1: boolean = false;
  setRotate2: boolean = false;
  setRotate3: boolean = false;
  setRotate4: boolean = false;
  setRotate5: boolean = false;
  setRotate6: boolean = false;
  setRotate7: boolean = false;
  setRotate8: boolean = false;
  setRotate9: boolean = false;
    premiumBreakUpAddonCovglist = [
    ['Terrorism Premium', null],
    ['Terrorism for Add-on  Premium', null],
    ['Forest Fire Premium', null],
    ['Architects, Surveyors Premium', null],
    ['Loss of Rent Premium', null],
    ['Additional Expense of Rent Premium', null],
    ['Removal of Debris Premium', null],
    ['Impact Damage Premium', null],
    ['Omission Premium', null]
  ];
  financierDetailsFormValid: boolean;
  premiumBreakUpBasicCovglist = [
    ['Basic Premium', null],
    ['STFI Premium', null],
    ['Earthquake Premium', null]
  ]
  isPremiumCalculated: boolean;
  showSumInsuredError = [];
  invalidNumberOfDaysOfStorage: boolean;
  isPolicyDateInvalid: boolean;
  isUPDateGSTNChecked: boolean;
  keyword = "gcShortDesc";
  policyEndDateToSavePeoposal: any;
  policyStartDateToSavePeoposal: any;
  packagingkeyword = "lookupValue";
  isAnyOtherNilEndorsementChecked!:any;
  isChangeinClientDetailsChecked!:any;

  submitted = false;
  isDobInvalid: boolean;
  currentDate: number;
  dobFutureDate: boolean;
  isMobilenumber2InValid: boolean;
  isMobilenumberInValid: boolean;
  isAlEmailIdInValid: boolean;
  isEmailIdInValid: boolean;
  isPolicyStartDate: boolean;
  mobileSpace: boolean;
  isPaymentByAgentBehalfIndicator: any;
  isPinCodeInvalid: boolean;
  PincodeMasterData: any;
  PinCodeList: any;
  promise: any;
  ifRequestAgentToPayment: boolean;
  isPaymentBehalfCustomer: boolean;
  isCustomerRejectionCommentsInvalid: boolean;
  emptyFieldError: boolean;
  selectedType: any;
  lineOfBusinessCode: string = '';
  businessValidations: any = {};
  policyEndDate: any;
  token: any = '';
  lobAndProductList = {};
  lobList: any;
  productData: any;
  formatblAwbLRrrCnDate: any;
  isCustomerTypeInvalid: boolean;
  customerDetailsList: any;
  searchParams = {
    imdCode: '',
    token: this.token,
  };
  customerDetailsForGetOtpParams = new getOTPForCustomerProposalAcceptanceModel();
  customerDetailsForValidateOtpParams = new validateOTPForCustomerProposalAcceptanceModel();
  rejectCustomerProposal = new RejectProposal();
  proposalsToPolicyParams = new updateProposalToPolicyModel();
  dataToDownloadPolicyWordings = { productCode: '', documentType: 'POLICYWORDINGS' }
  generalFAQs: { question: string, is_answer_multiple: boolean, answer: string[] }[] = product_related;
  generalallFAQs: { question: string, is_answer_multiple: boolean, answer: string[] }[] = general;


  inputForPayment = {
    paymentDetails: {
      transactionId: '94204CE9030820162402E1DK',
      amount: 0,
      productInfo: '',
      firstName: '',
      emailAddress: '',
      phoneNumber: '',
      proposalNo: '',
      activityName: 'customer proposal'
    }
  };
  proposalInput = {
    proposalNumber: ''
  };
  maskedMobileNumber: string;
  uploadedDocumentCount = 0;
  uploadedDocumentList;
  docDataSet = {};
  uploadedFilesList = [];
  previousPolicyData = [];
  searchText: any;
  filtersLoaded: Promise<boolean>;
  dataToDownloadBrochure = {
    productCode: '',
    documentType: 'BROCHURE'
  };
  isPinCodeValid: boolean;
  ifProposalRejected = false;
  ifProposalAccepted = false;
  isEditCustomerProposal = false;
  isCustomerProposalMakePayment = false;
  tempProposalNumber: string;
  acceptProposalOtpResponse: any;
  dataForPdf: any;
  blob: Blob;
  isOTPInvalid: boolean;
  isOTPTimedOut: boolean;
  paymentResponse: any;
  financierList = [];
  invoiceList = [];
  salutationList: any;
  proposalDataByNumber: any;
  EndorsementDate: any;
  customerTypeList: any;
  customerProposalTotalResponse: any;
  customerProposalRateList: any;
  newPolicyDetails: any;
  oldPolicyDetails: any;
  isCustomerProposalMakePaymentSuccess: boolean;
  policyStartDate: any;
  DateofBirthEditProposal: any;
  isCheckSelected = false;
  agreementData: any;
  CCWEInfo: any;
  endorsementType: any;
  disableAllEn = false;
  isEndorsement = false;
  premiumAfterCalculateNull: boolean;
  masterDataForMarine: any;
  voyageTypes: any = [];
  customerProposalEditParams: any = {

  };
  customerRejectCommentsDetails = {
    comment: '',
    userCode: '',
    createdBy: '',
    time: '',
  }
  masterDataForQuote: any;
  productCode: string;
  disableControls: boolean;
  customer: any;
  accordianList = [];
  masterDataForMO: any;
  transitArray: any;
  salesVoyageType = [];
  capitalItemVoyageType = [];
  purchasesVoyageType = [];
  otherVoyageType = [];
  showBovPercentageValidation: boolean;
  gcvoyageType = [];
  typeOfLookup = [];
  typeOFLandClone: any[];
  typeOFLand: any;
  modeOfConveaynceClone: any = [];
  clonedModeOfConveyance = [];
  showTypeOfLandConveyance = [];
  perLocationValid = [];
  marineOpenProposalModel: any;

  constructor(private newProposalService: NewProposalService, public commonService: CommonService, public datepipe: DatePipe, private newQuoteService: NewQuoteService, private router: Router,
    private route: ActivatedRoute, private customerProposalService: customerProposalService, private createQuoteService: CreateQuoteService,
    private paymentService: PaymentPendingService, private el: ElementRef, private notifyService: NotificationService, public commonMethodService: CommonMethodService, ) { }

  ngOnInit() {
    this.agreementTypeData();
    this.getCCWEInfo();
    this.currentDate = this.getCurrentDate();
    // //console.log("fff=", this.generalFAQs);
    this.route.queryParams.subscribe(params => {
      if (params.hasOwnProperty('proposalNo')) {
        this.tempProposalNumber = params.proposalNo;
      } else {
        this.tempProposalNumber = params.proposalNumber;
      }
      this.isEndorsement = this.tempProposalNumber.includes('EN') ? true : false;
      this.isEndorsement ? this.proposalInput['endorsmentNumber'] = this.tempProposalNumber : this.proposalInput['proposalNumber'] = this.tempProposalNumber;
      this.proposalInput.proposalNumber = this.tempProposalNumber;
      this.getUploadedDocuments(this.tempProposalNumber);
      // if (this.isEndorsement) {
      //   this.getEndorementTypes();
      // }

      this.customerProposalService.getPaymentByAgentBehalfIndicator(this.proposalInput).subscribe(res => {
        this.isPaymentByAgentBehalfIndicator = res;
      });
      if (Object.keys(params).length > 1) {
        this.paymentResponse = params;
        this.updateTransactionDetailsAfterPayment();

      }
    });

    this.getCustomerDetailsById();
    this.getCustomerTypeList();
    this.getMasterDataForMStop();
    setTimeout(() => {
      this.tooltipInit();
    }, 2000);

    setTimeout(() => {
      this.tooltipInit();
    }, 6000);

    setTimeout(() => {
      this.tooltipInit();
    }, 10000);

  }

  getCurrentDate() {
    var currentDate = new Date();
    return currentDate.setDate(currentDate.getDate());
  }

  rotateIcon(iconId: number) {
    switch (iconId) {
      case 0:
        this.setRotate0 = !this.setRotate0;
        break;
      case 1:
        this.setRotate1 = !this.setRotate1;
        break;
      case 2:
        this.setRotate2 = !this.setRotate2;
        break;
      case 3:
        this.setRotate3 = !this.setRotate3;
        break;
      case 4:
        this.setRotate4 = !this.setRotate4;
        break;
      case 5:
        this.setRotate5 = !this.setRotate5;
        break;
      case 6:
        this.setRotate6 = !this.setRotate6;
        break;
      case 7:
        this.setRotate7 = !this.setRotate7;
        break;
      case 8:
        this.setRotate8 = !this.setRotate8;
        break;

    }

    setTimeout(() => {
      this.tooltipInit();
    }, 2000);
    setTimeout(() => {
      this.tooltipInit();
    }, 4000);
    setTimeout(() => {
      this.tooltipInit();
    }, 7000);

  }
  autoGrowTextZone(e) {
    e.target.style.height = "0px";
    e.target.style.height = (e.target.scrollHeight + 15) + "px";
  }
  tooltipInit() {
    $(document).ready(function () {
      $('[data-toggle="tooltip"]').tooltip();
    });
  }

  getNumberInDecimal(value) {
    return parseFloat(value).toFixed(2);
  }

  onChangeCustomerType(customerType) {
    if (customerType == 'I') {
      this.isCustomerTypeInvalid = false;
      this.commonService.getSalutation('Individual').subscribe(res => {
        this.salutationList = res;
        this.salutationList = this.salutationList.keyValuePairList.keyValuePairList;
      });
    } else if (customerType == 'C') {
      //   // this.isCustomerTypeInvalid = true;
      this.salutationList = [{
        name: 'M/S'
      }
      ];
    }
  }

  getCustomerDetailsById() {
    this.ifRequestAgentToPayment = false;
    this.isPinCodeValid = true;
    this.searchParams.imdCode = this.commonService.getUserName();
    this.searchParams.token = this.token;
    this.customerProposalService.getMarineStopCustomerProposalDetails(this.tempProposalNumber + '').subscribe((res: any) => {
      this.filtersLoaded = Promise.resolve(true);
      this.proposalDataByNumber = res;
      this.customerDetailsList = res.inputRequest;
      this.onChangeCustomerType(this.customerDetailsList.customerDetails.customerType);
      //console.log("ccdd=", this.customerDetailsList);
      this.customerProposalTotalResponse = res;
      // this.marineOpenProposalModel = res;

      if (this.customerDetailsList.typeOfBusiness == 'Roll Over') {
        this.previousPolicyData = this.customerDetailsList.PASTPOLICY['PASTPOLICYDETAILS'];
        if (!('conditions' in this.customerProposalTotalResponse)) {
          this.customerProposalTotalResponse.conditions = [];
        }
      }

      this.customerTypeMapping();

      localStorage.setItem('gc_proposalNo', res.gcProposalNumber);
      localStorage.setItem('CustomerID', res.customerId);
      localStorage.setItem('ProposalNumber', res.proposalNumber);
      this.maskedMobileNumber = this.customerDetailsList.customerDetails.mobileNumber.toString().replace(/^(\d{3})\d(?=\d{3})|\d(?=\d{3})/g, '$1*');
      if ('oldPolicyDetails' in this.customerProposalTotalResponse) {
        this.newPolicyDetails = this.customerProposalTotalResponse.inputRequest;
        this.oldPolicyDetails = this.customerProposalTotalResponse.oldPolicyDetails;
        this.commonMethodService.filterAndAddBothValues(((this.commonMethodService.arrangeDataArr(this.commonMethodService.getKeyValues(this.newPolicyDetails)).flat())).flat(Infinity),
          ((this.commonMethodService.arrangeDataArr(this.commonMethodService.getKeyValues(this.oldPolicyDetails)).flat())).flat(Infinity));
      }
      //console.log(this.customerProposalTotalResponse);
      if (this.customerProposalTotalResponse.status == 'Rejected by Customer' || this.customerProposalTotalResponse.status == 'EN Rejected by customer') {
        this.ifProposalRejected = true;
      } else if
        (this.customerProposalTotalResponse.status == 'Payment Pending' || this.customerProposalTotalResponse.status == 'EN Pending Payment') {
        this.ifProposalAccepted = true;
      } else if (this.customerProposalTotalResponse.status == '') {
        this.isCustomerProposalMakePaymentSuccess = true;
      }
      if (this.customerProposalTotalResponse.isAgentPayment == true) {
        this.ifRequestAgentToPayment = true;
      } else {
        this.ifRequestAgentToPayment = false;
      }
      if (this.customerProposalTotalResponse.isPaymentBehalfCustomer) {
        this.isPaymentBehalfCustomer = false;
      } else {
        this.isPaymentBehalfCustomer = true;
      }
      if (this.ifProposalAccepted == true || this.customerProposalTotalResponse.status == 'In force') {
        this.isCheckSelected = true;
      }
      this.tooltipInit();

    }
    );
  }
  agreementTypeData() {
    this.commonService.agreementTypeData().subscribe(res => {
      this.agreementData = res;
    });
  }

  getUploadedDocuments(proposalNumber) {
    // this.newProposalService.getUploadedDocuments(proposalNumber).subscribe(res => {
    //   this.uploadedDocumentList = res;
    //   this.uploadedDocumentCount = this.uploadedDocumentList != null ? this.uploadedDocumentList.length : 0;
    //   this.prepareUploadedFileData();
    // });
  }

  updateTransactionDetailsAfterPayment() {
    this.proposalsToPolicyParams.proposalNos.push(localStorage.getItem('gc_proposalNo'));
    this.proposalsToPolicyParams.partnerproposalNos.push(localStorage.getItem('ProposalNumber'));
    this.proposalsToPolicyParams.officeCode = null;
    this.proposalsToPolicyParams.paymentBy = 'INTERMEDIARY';
    this.proposalsToPolicyParams.transactionDetails.amount = this.paymentResponse.amount;
    this.proposalsToPolicyParams.transactionDetails.email = this.paymentResponse.email;
    this.proposalsToPolicyParams.transactionDetails.error = this.paymentResponse.error;
    this.proposalsToPolicyParams.transactionDetails.hashCode = this.paymentResponse.hash;
    this.proposalsToPolicyParams.transactionDetails.mId = this.paymentResponse.mihpayid;
    this.proposalsToPolicyParams.transactionDetails.mode = this.paymentResponse.mode;
    this.proposalsToPolicyParams.transactionDetails.payerCustomerId = localStorage.getItem('CustomerID');
    this.proposalsToPolicyParams.transactionDetails.pgType = this.paymentResponse.PG_TYPE;
    this.proposalsToPolicyParams.transactionDetails.status = this.paymentResponse.status;
    this.proposalsToPolicyParams.transactionDetails.transactionId = this.paymentResponse.txnid;
    this.proposalsToPolicyParams.transactionDetails.unmappedStatus = this.paymentResponse.unmappedstatus;
    if (this.proposalsToPolicyParams.transactionDetails.status == 'success') {
      this.isCustomerProposalMakePaymentSuccess = true;
      this.notifyService.showSuccess('Payment has been completed successfully, policy details will be shared soon', 'Payment Notification');
      this.commonService.getToken().subscribe(
        (token) => {
          this.proposalsToPolicyParams.tokenId = token;
          this.commonService.convertProposalToPolicyOnPaymentSuccess(this.proposalsToPolicyParams).subscribe(paymentres => {
            this.notifyService.showSuccess(paymentres + '.', 'Policy Notification');
          });
        });
    }
  }


  getCustomerTypeList() {
    this.commonService.getCustomerType().subscribe(res => {
      this.customerTypeList = res;
    });
  }
  getCCWEInfo() {
    //need to change the voyage type and commodity details for ccwe 
    this.newQuoteService.getCCWEInfoMarineOpen().subscribe(res => {
      this.CCWEInfo = res;

    });
  }

  downloadCustomerProposalDataBrochure() {
    this.dataToDownloadBrochure.productCode = '21';
    this.commonService.downloadCustomerProposalDataBrochure(this.dataToDownloadBrochure).subscribe(
      (res) => {
        this.dataForPdf = res;
        this.blob = new Blob([this.dataForPdf], { type: 'application/pdf' });
        const downloadURL = window.URL.createObjectURL(this.blob);
        const link = document.createElement('a');
        link.href = downloadURL;
        link.download = 'Brochure.pdf';
        link.click();
      },
      (error: HttpErrorResponse) => {
      }
    );
  }

  downloadCustomerPolicyWordings() {
    this.dataToDownloadPolicyWordings.productCode = this.customerDetailsList.ProductCode;
    this.commonService.downloadCustomerProposalDataBrochure(this.dataToDownloadPolicyWordings).subscribe(
      (res) => {
        this.dataForPdf = res;
        this.blob = new Blob([this.dataForPdf], { type: 'application/pdf' });
        const downloadURL = window.URL.createObjectURL(this.blob);
        const link = document.createElement('a');
        link.href = downloadURL;
        link.download = 'PolicyWordings.pdf';
        link.click();
      },
      (error: HttpErrorResponse) => {
      }
    );
  }

  onCheckTerms() {
    this.isCheckSelected = !this.isCheckSelected;
  }

  editCustomerproposal() {
    if (this.isEndorsement) {
      // this.selectedEndorsementType(event, type);
      this.disableControls = true;
      this.disableAllEn = true;
    }
    this.getMasterDataForQuote();
    this.tooltipInit();
    setTimeout(() => {
      this.tooltipInit();
    }, 3000);
    // this.disableControls = true;
    this.customerProposalService.getMarineOpenCustomerProposalDetails(this.tempProposalNumber).subscribe((res: any) => {
      this.customerProposalEditParams = res.inputRequest;
      //console.log(this.customerProposalEditParams)
      this.customerProposalEditParams.sumInsured = this.commonMethodService.formatNumberToINR(this.customerProposalEditParams.sumInsured);
      // this.customerProposalList.proposalNumber = res.proposalNumber;
      this.customerProposalRateList = res;
      if (res.inputRequest.EndorsementTypes) {
        // this.setEndorsementType(res.inputRequest.EndorsementTypes);
      }
      this.policyStartDate = this.customerProposalRateList.inputRequest.policyStartDate;
      this.policyStartDate = this.policyStartDate.substring(6) + '-' + this.policyStartDate.substring(3, 5) + '-' + this.policyStartDate.substring(0, 2);
      this.policyEndDate = this.customerProposalRateList.inputRequest.policyEndDate;
      this.policyEndDate = this.policyEndDate.substring(6) + '-' + this.policyEndDate.substring(3, 5) + '-' + this.policyEndDate.substring(0, 2);
      this.isEditCustomerProposal = true;
      this.customerTypeMapping();
      // this.customerProposalEditParams.riskDetails.voyageExpectedDate = this.customerProposalEditParams.riskDetails.voyageExpectedDate.substring(6) + '-' + this.customerProposalEditParams.riskDetails.voyageExpectedDate.substring(3, 5) + '-' + this.customerProposalEditParams.riskDetails.voyageExpectedDate.substring(0, 2);
      if (this.isEndorsement) {
        // this.mapVoyageTypeEdit();
      } else {
        this.mapVoyageType();
      }
      //   this.customerTypeReMapping();
      this.customerProposalEditParams.riskDetails = this.customerProposalRateList.inputRequest.riskDetails;
      this.customerProposalEditParams.riskDetails.forEach((riskdetail, ri) => {
        this.mapModeOfConveyance(ri);
        if (riskdetail.voyageDetails.typeofLandConveyanc && riskdetail.voyageDetails.typeofLandConveyanc.length > 0) {
          this.showTypeOfLandConveyance[ri] = true;
          this.mapTypeofConveyance(ri);
        }
        riskdetail.basisofDeclaration = '';
        this.onVoyageTypeChangePopulateForGc(riskdetail.voyageType, ri);
      });
      this.DateofBirthEditProposal = this.customerProposalRateList.inputRequest.customerDetails.dateOfBirth;
      this.DateofBirthEditProposal = this.DateofBirthEditProposal.substring(6) + '-' + this.DateofBirthEditProposal.substring(3, 5) + '-' + this.DateofBirthEditProposal.substring(0, 2);
      this.financierList = res.inputRequest.financier.financierDetails;
      this.invoiceList = res.inputRequest.InvoiceDetails;
      this.customer = res.inputRequest.customerDetails.customerType;
    });
  }

  getMasterDataForQuote() {
    let imdcode = this.commonService.getUserName();
    this.commonService.getMasterDataForMarineOpen(21, this.productCode, imdcode).subscribe((res) => {
      this.masterDataForQuote = res;
    });
  }

  getMasterDataForMStop() {
    let imdcode = this.commonService.getUserName();
    this.commonService.getMasterDataForMarineOpen(34, 3414, imdcode).subscribe((res) => {
      this.masterDataForMO = res;
      //console.log(this.masterDataForMO);
      this.voyageTypes = this.masterDataForMarine.voyageType;
      this.salesVoyageType = this.voyageTypes.filter(salesVoyageType => salesVoyageType.otherDesc === 'sales');
      this.capitalItemVoyageType = this.voyageTypes.filter(salesVoyageType => salesVoyageType.otherDesc === 'capitalItem');
      this.purchasesVoyageType = this.voyageTypes.filter(salesVoyageType => salesVoyageType.otherDesc === 'purchases');
      this.otherVoyageType = this.voyageTypes.filter(salesVoyageType => salesVoyageType.otherDesc === 'others');


      this.modeOfConveaynceClone = JSON.parse(JSON.stringify(this.masterDataForMO.modeOfConveyance));
      this.typeOFLand = JSON.parse(JSON.stringify(this.masterDataForMO.typeOfLandConveyance));
      this.typeOFLandClone = [...this.typeOFLand];

      this.customerProposalEditParams.typeOfBusiness =
        this.masterDataForMarine.BUSINESS_TYPE.find(x => x.lookupDescription === 'New Business').lookupValue;
    });
  }
  // mapVoyageType() {
  //   this.voyageTypes.forEach(type => {
  //     this.customerProposalEditParams.riskDetails.forEach(riskDetail => {
  //       if (riskDetail['voyageType'] === type.lookupValue) {
  //         type.checked = true;
  //       }
  //     });
  //   });
  // }

  mapVoyageType() {
    this.voyageTypes.forEach(type => {
      this.customerProposalEditParams.riskDetails.forEach(riskDetail => {
        this.masterDataForMO.voyageType.forEach((ele, index) => {
          if (riskDetail['voyageType'] == ele.lookupValue) {

            this.gcvoyageType.push(ele.lookupDescription);
          }
        });
        if (riskDetail['voyageType'] === type.lookupValue) {
          type.checked = true;
          if (riskDetail['voyageType'] === 'Containers Inland' || riskDetail['voyageType'] === 'Capital Items Inland'
            || riskDetail['voyageType'] === 'Domestic Purchases'
            || riskDetail['voyageType'] === 'Domestic Sales' || riskDetail['voyageType'] === 'Stock Transfers/Inter-Depot/Sub -Contractors Movements') {
            riskDetail.voyageDetails.transitFrom = 'Anywhere in India';
            riskDetail.voyageDetails.transitTo = 'Anywhere in India';
          } else
            if (riskDetail['voyageType'] === 'Capital Items Import' || riskDetail['voyageType'] === 'Import Purchases'
              || riskDetail['voyageType'] === 'Deemed/Contingent duty' || riskDetail['voyageType'] === 'Mercantile Trade') {
              riskDetail.voyageDetails.transitFrom = 'Anywhere in the World';
              riskDetail.voyageDetails.transitTo = 'Anywhere in India';
            } else
              if (riskDetail['voyageType'] === 'Export Sales' || riskDetail['voyageType'] === 'Capital Item Export') {
                riskDetail.voyageDetails.transitFrom = 'Anywhere in India';
                riskDetail.voyageDetails.transitTo = 'Anywhere in the World';
              } else
                if (riskDetail['voyageType'] === 'Cross Voyage') {
                  riskDetail.voyageDetails.transitFrom = 'Anywhere in the World';
                  riskDetail.voyageDetails.transitTo = 'Anywhere in the World';
                }
        }


      });
    });
  }

  isfinancierDetailsFormValid(formValid: any) {
    this.financierDetailsFormValid = formValid;
  }

  dynamicAccor(accirId: number) {
    this.accordianList[accirId] = !this.accordianList[accirId];
  }

  onVoyageTypeChangeForGc(event, vi) {
    this.masterDataForMO.voyageType.forEach((ele, index) => {
      if (vi == index) {

        this.gcvoyageType.push(ele.lookupDescription);
      }
    })
  }
  
  autoPopulateOverageExtra(event, riskIndex) {
    if (this.masterDataForMO.VESSEL_TYPE_OR_AGE_BAND && this.masterDataForMO.VESSEL_TYPE_OR_AGE_BAND.length > 0) {
      this.masterDataForMO.VESSEL_TYPE_OR_AGE_BAND.forEach((vesselType) => {
        if (vesselType.lookupValue === event) {
          this.marineOpenProposalModel.riskDetails[riskIndex]['overrageExtra'].loading = vesselType.otherDesc;
        }
      })
    }

  }

  sumOfSumInsured(riskIndex) {
    let increasedValueSI = 0;
    let importDuty = 0;
    let cargoSI = 0;
    let dutyOnlySI = 0;
    if (this.marineOpenProposalModel.riskDetails[riskIndex]['sumInsuredDetails']['increasedValueSI']) {
      increasedValueSI = parseInt(this.marineOpenProposalModel.riskDetails[riskIndex]['sumInsuredDetails']['increasedValueSI'])
    } if (this.marineOpenProposalModel.riskDetails[riskIndex]['sumInsuredDetails']['importDuty']) {
      importDuty = parseInt(this.marineOpenProposalModel.riskDetails[riskIndex]['sumInsuredDetails']['importDuty'])
    } if (this.marineOpenProposalModel.riskDetails[riskIndex]['sumInsuredDetails']['cargoSI']) {
      cargoSI = parseInt(this.marineOpenProposalModel.riskDetails[riskIndex]['sumInsuredDetails']['cargoSI'])
    } if (this.marineOpenProposalModel.riskDetails[riskIndex]['sumInsuredDetails']['dutyOnlySI']) {
      dutyOnlySI = parseInt(this.marineOpenProposalModel.riskDetails[riskIndex]['sumInsuredDetails']['dutyOnlySI'])

    }
    const sumOfSumInsured = increasedValueSI + importDuty + cargoSI + dutyOnlySI;
    if (parseInt(this.marineOpenProposalModel.riskDetails[riskIndex]['voyageDetails']['perSendingLimit']) > sumOfSumInsured) {
      this.showSumInsuredError[riskIndex] = true;
    } else {
      this.showSumInsuredError[riskIndex] = false;
    }
  }

  onCommodityChanges(event, text?: string) {
    if (text === 'fromHtml') {
      event = event.gcShortDesc
    }
    this.masterDataForMO.COMMODITY_TYPE.forEach((ele, index) => {
      if (event == ele.gcShortDesc) {
        this.marineOpenProposalModel['commodityCode'] = ele.lookupValue
      }
    })
  }

  onTypesOfLandConeyanceChange(event, riskIndex, pIndex) {
    //this.typeOfLookup[riskIndex] = [...this.typeOFLandClone];
    this.typeOfLookup[riskIndex].forEach((ele, index) => {
      if (pIndex == index) {
        if (event) {
          ele.checked = true;
          //this.marineOpenProposalModel.riskDetails[pIndex]['voyageDetails'] = new VoyageDetails('', '', [],[]);
          this.marineOpenProposalModel.riskDetails[riskIndex]['voyageDetails']['typeofLandConveyanc'].push(ele.lookupValue);
        } else {
          ele.checked = false;
          this.marineOpenProposalModel.riskDetails[riskIndex]['voyageDetails']['typeofLandConveyanc'].forEach((modeOfConv, cindex) => {
            if (modeOfConv == ele.lookupValue) {
              this.marineOpenProposalModel.riskDetails[riskIndex]['voyageDetails']['typeofLandConveyanc'].splice(cindex, 1);
            }
          });
        }
      }
    });
  }

  daysValidation(event) {
    if (+event.target.value < 0 || +event.target.value > 30) {
      this.invalidNumberOfDaysOfStorage = true;
      return false;
    }
    this.invalidNumberOfDaysOfStorage = false;
    return true;
  }

  onModeOfConeyanceChange(event, riskIndex, iModOfConv) {
    this.clonedModeOfConveyance[riskIndex] = JSON.parse(JSON.stringify(this.modeOfConveaynceClone));
    this.clonedModeOfConveyance[riskIndex].forEach((ele, index) => {
      if (iModOfConv == index) {
        if (event) {
          ele.checked = true;
          if (ele.lookupValue === 'Rail / Road' || ele.lookupValue === 'Rail' || ele.lookupValue === 'Road') {
            this.showTypeOfLandConveyance[riskIndex] = true;
            const copyOfTypeOfConveyance = JSON.parse(JSON.stringify(this.masterDataForMO.typeOfLandConveyance));
            copyOfTypeOfConveyance[1].checked = true;
            this.typeOfLookup[riskIndex] = copyOfTypeOfConveyance;
            this.marineOpenProposalModel.riskDetails[riskIndex]['voyageDetails']['typeofLandConveyanc'].push('Truck');

          }
          // this.marineOpenProposalModel.riskDetails[pIndex]['voyageDetails'] = new VoyageDetails('', '', []);
          this.marineOpenProposalModel.riskDetails[riskIndex]['voyageDetails']['modeOfCoveyance'].push(ele.lookupValue);
        } else {
          ele.checked = false;
          this.marineOpenProposalModel.riskDetails[riskIndex]['voyageDetails']['modeOfCoveyance'].forEach((modeOfConv, cindex) => {
            if (modeOfConv == ele.lookupValue) {
              this.marineOpenProposalModel.riskDetails[riskIndex]['voyageDetails']['modeOfCoveyance'].splice(cindex, 1);
              if (
                !this.marineOpenProposalModel.riskDetails[riskIndex]['voyageDetails']['modeOfCoveyance'].includes('Rail / Road')
                && !this.marineOpenProposalModel.riskDetails[riskIndex]['voyageDetails']['modeOfCoveyance'].includes('Road')
                && !this.marineOpenProposalModel.riskDetails[riskIndex]['voyageDetails']['modeOfCoveyance'].includes('Rail')
              ) {
                this.showTypeOfLandConveyance[riskIndex] = false;
                this.marineOpenProposalModel.riskDetails[riskIndex]['voyageDetails']['typeofLandConveyanc'] = [];

              }
            }
          });
        }
      }
    });
  }

  onVoyageTypeChangeRisk(event, pIndex, voyageType) {
    let voyageTypeArray = [];
    if (voyageType === 'sales') {
      voyageTypeArray = this.salesVoyageType;
    } else if (voyageType === 'capital') {
      voyageTypeArray = this.capitalItemVoyageType;
    } else if (voyageType === 'purchase') {
      voyageTypeArray = this.purchasesVoyageType;
    } else if (voyageType === 'others') {
      voyageTypeArray = this.otherVoyageType;
    }
    voyageTypeArray.forEach((ele, index) => {
      if (pIndex == index) {
        if (event) {
          ele.checked = true;
          let tempObj: RiskDetailsMarineOpen = new RiskDetailsMarineOpen();
          tempObj.voyageTypeLookupValue = ele.lookupValue;
          tempObj.voyageType = ele.lookupValue;
          tempObj.modeOfConveyanceLookup = JSON.parse(JSON.stringify(this.masterDataForMO.modeOfConveyance));
          tempObj.riskFeature.geographicalTransitLimits = 'Within State/City Limits';
          tempObj.riskFeature.typeOfStorage = 'Closed Storage';
          tempObj.riskFeature.claimsExperience = 'Upto 75%';
          tempObj.riskFeature.destination = 'Land Locked';
          tempObj.commodityRiskDetails = new CommodityRiskDetails('Containerized  Cargo', 'Containerized', 'FCL', 'No', '', '10', 'Destination Site', 'Certificate');
          tempObj.deductibleDetails = new DeductibleDetails('SI Basis', 0, 0.5, 10000, 0, 0, '');
          if (tempObj['voyageType'] === 'Containers Inland' || tempObj['voyageType'] === 'Capital Items Inland'
            || tempObj['voyageType'] === 'Domestic Purchases'
            || tempObj['voyageType'] === 'Domestic Sales' || tempObj['voyageType'] === 'Stock Transfers/Inter-Depot/Sub -Contractors Movements') {
            tempObj.voyageDetails.transitFrom = 'Anywhere in India';
            tempObj.voyageDetails.transitTo = 'Anywhere in India';
          } else
            if (tempObj['voyageType'] === 'Capital Items Import' || tempObj['voyageType'] === 'Import Purchases'
              || tempObj['voyageType'] === 'Deemed/Contingent duty' || tempObj['voyageType'] === 'Mercantile Trade') {
              tempObj.voyageDetails.transitFrom = 'Anywhere in the World';
              tempObj.voyageDetails.transitTo = 'Anywhere in India';
            } else
              if (tempObj['voyageType'] === 'Export Sales' || tempObj['voyageType'] === 'Capital Item Export') {
                tempObj.voyageDetails.transitFrom = 'Anywhere in India';
                tempObj.voyageDetails.transitTo = 'Anywhere in the World';
              } else
                if (tempObj['voyageType'] === 'Cross Voyage') {
                  tempObj.voyageDetails.transitFrom = 'Anywhere in the World';
                  tempObj.voyageDetails.transitTo = 'Anywhere in the World';
                }

          tempObj.commodityDetail = new CommodityDetail('', '', '', '');
          this.marineOpenProposalModel.riskDetails.push(tempObj);
          this.autoPopulateFields(this.marineOpenProposalModel.commodity);
          this.autoPopulatePackagingFields(this.marineOpenProposalModel.packagingShortDescription, 0, 1);
        } else {
          ele.checked = false;
          this.marineOpenProposalModel.riskDetails.forEach((riskDetail, cindex) => {
            if (riskDetail.voyageTypeLookupValue == ele.lookupValue) {
              this.marineOpenProposalModel.riskDetails.splice(cindex, 1);
              if (riskDetail.voyageDetails.typeofLandConveyanc && riskDetail.voyageDetails.typeofLandConveyanc.length > 0) {
                this.typeOfLookup.splice(cindex, 1);
                this.showTypeOfLandConveyance.splice(cindex, 1);
              }

            }

          });
        }
      }
    });
  }
  
  autoPopulatePackagingFields(event, riskIndex, cindex, text?: string) {
    if (text === 'fromHtml') {
      event = event.lookupValue;
    }

    if (this.masterDataForMO.TYPE_OF_PACKING && this.masterDataForMO.TYPE_OF_PACKING.length > 0) {
      if (event) {
        this.masterDataForMO.TYPE_OF_PACKING.forEach((packaging) => {
          if (packaging.lookupValue === event) {
            this.marineOpenProposalModel.riskDetails.forEach(riskDetail => {
              riskDetail['commodityDetail']['packagingLongDescription'] = packaging.lookupDescription;

            });

          }
        });
      } else {
        this.marineOpenProposalModel.riskDetails.forEach(riskDetail => {
          riskDetail['commodityDetail']['packagingLongDescription'] = '';

        });

      }
    }

  }

  prevoiusPolicyDatescheck() {
    this.isPolicyDateInvalid = false;
    if (this.policyEndDateToSavePeoposal != '' && this.policyEndDateToSavePeoposal != null && this.policyStartDateToSavePeoposal != '' && this.policyStartDateToSavePeoposal != null) {
      if (new Date(this.policyEndDateToSavePeoposal) > new Date(this.policyStartDateToSavePeoposal)) {
        this.isPolicyDateInvalid = false;
        //return true;
      } else {
        this.isPolicyDateInvalid = true;
        //return false;
      }
    }
  }
  autoPopulateFields(event, text?: string) {
    if (text === 'fromHtml') {
      event = event.gcShortDesc;
    }
  }

  mapModeOfConveyance(ri) {
    this.clonedModeOfConveyance[ri] = JSON.parse(JSON.stringify(this.modeOfConveaynceClone));
    this.clonedModeOfConveyance[ri].forEach(type => {
      if (this.customerProposalEditParams.riskDetails[ri]['voyageDetails']['modeOfCoveyance'].length > 0) {
        this.customerProposalEditParams.riskDetails[ri]['voyageDetails']['modeOfCoveyance'].forEach(modOfCov => {
          if (modOfCov === type.lookupValue) {
            type.checked = true;
          }
        });
      }
    });

    this.customerProposalEditParams.riskDetails[ri].modeOfConveyanceLookup = this.clonedModeOfConveyance[ri];

  }

  mapTypeofConveyance(riskIndex) {
    this.typeOfLookup[riskIndex] = JSON.parse(JSON.stringify(this.typeOFLandClone));
    this.typeOfLookup[riskIndex].forEach(type => {
      if (this.customerProposalEditParams.riskDetails[riskIndex]['voyageDetails']['typeofLandConveyanc'].length > 0) {
        this.customerProposalEditParams.riskDetails[riskIndex]['voyageDetails']['typeofLandConveyanc'].forEach(modOfCov => {
          if (modOfCov === type.lookupValue) {
            type.checked = true;
          }
        });

      }
    });
  }

  onVoyageTypeChangePopulateForGc(event, riskIndex) {
    this.masterDataForMO.voyageType.forEach((ele, index) => {
      if (event == ele.lookupValue) {

        this.customerProposalEditParams.riskDetails[riskIndex]['gcvoyageType'] = ele.lookupDescription;
      }
    })
  }

  getOtpForProposalAcceptance() {
    if (this.isCheckSelected == true) {
      this.customerDetailsForValidateOtpParams.otp = '';
      this.isOTPInvalid = false;
      this.isOTPTimedOut = false;
      this.customerDetailsForGetOtpParams.customerId = this.commonService.getUserName();
      this.customerDetailsForGetOtpParams.customerLastName = this.customerDetailsList.customerDetails.lastName;
      this.customerDetailsForGetOtpParams.salutation = this.customerDetailsList.customerDetails.salutation;
      this.customerDetailsForGetOtpParams.proposalNumber = this.customerProposalTotalResponse.proposalNumber;
      this.customerDetailsForGetOtpParams.emailId = this.customerDetailsList.customerDetails.emailId;
      this.customerDetailsForGetOtpParams.mobileNumber = this.customerDetailsList.customerDetails.mobileNumber;
      this.customerDetailsForGetOtpParams.productId = this.customerDetailsList.ProductCode;
      this.customerDetailsForGetOtpParams.productName = this.customerDetailsList.product;
      if (this.tempProposalNumber.includes('EN')) {
        this.customerDetailsForGetOtpParams.endorsementNumber = this.customerProposalTotalResponse.endorsementNumber;
        this.customerDetailsForGetOtpParams.modeofOperation = this.customerProposalTotalResponse.inputRequest.ModeOfOperation;
      } else {
        this.customerDetailsForGetOtpParams.modeofOperation = this.customerProposalTotalResponse.inputRequest.ModeOfOperation;
      }

      this.customerProposalService.getOtpForMarineStop(this.customerDetailsForGetOtpParams).subscribe((res) => {
        this.acceptProposalOtpResponse = res;
      });
    } else {
      this.notifyService.showInfo('Please confirm the declaration before accepting the proposal', 'Customer Profile Notification');
    }
  }

  acceptedProposal() {
    this.emptyFieldError = false;
    if (this.customerDetailsForValidateOtpParams.otp == '') {
      this.emptyFieldError = true;
    } else {
      this.isOTPInvalid = false;
      this.isOTPTimedOut = false;
      this.customerDetailsForGetOtpParams.customerId = this.customerDetailsList.customerDetails.customerID;
      this.customerDetailsForValidateOtpParams.customerLastName = this.customerDetailsList.customerDetails.lastName;
      this.customerDetailsForValidateOtpParams.salutation = this.customerDetailsList.customerDetails.salutation;
      this.customerDetailsForValidateOtpParams.proposalNumber = this.customerProposalTotalResponse.proposalNumber;
      this.customerDetailsForValidateOtpParams.mobileNumber = this.customerDetailsList.customerDetails.mobileNumber;
      this.customerDetailsForValidateOtpParams.productId = this.customerDetailsList.ProductCode;
      this.customerDetailsForValidateOtpParams.productName = this.customerDetailsList.product;
      if (this.tempProposalNumber.includes('EN')) {
        this.customerDetailsForValidateOtpParams.endorsementNumber = this.customerProposalTotalResponse.endorsementNumber;
        this.customerDetailsForValidateOtpParams.modeofOperation = this.customerProposalTotalResponse.inputRequest.ModeOfOperation;
      } else {
        this.customerDetailsForValidateOtpParams.modeofOperation = this.customerProposalTotalResponse.inputRequest.ModeOfOperation;
      }
      this.customerProposalService.validateOtpForMarineStop(this.customerDetailsForValidateOtpParams).subscribe((res) => {
        switch (res) {
          case 'OTP Valid': this.customerProposalService.getPaymentByAgentBehalfIndicator(this.proposalInput).subscribe(res => {
            this.isPaymentByAgentBehalfIndicator = res;
            $('#AcceptProposal').modal('hide');
            this.ifProposalAccepted = true;
          });
            break;
          case 'OTP Invalid': this.isOTPInvalid = true;
            this.isOTPTimedOut = false;
            break;
          case 'OTP Expired': this.isOTPTimedOut = true;
            this.isOTPInvalid = false;
            break;
        }
      });
    }
  }
  NumberOnlyInput(event) {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  CancelEditButton() {
    this.isEditCustomerProposal = false;
    this.isCheckSelected = false;
    setTimeout(() => {
      this.tooltipInit();
    }, 1000);
  }

  requestAgentPayment() {
    this.customerProposalService.requestAgentToMakePaymentMarineOpen(this.tempProposalNumber).subscribe((res: any) => {
      this.ifRequestAgentToPayment = true;
    }
    );
  }

  makePayment() {
    this.isCustomerProposalMakePayment = true;
    this.inputForPayment.paymentDetails.amount = this.customerProposalTotalResponse.brmsResponse.totalPremium;
    this.inputForPayment.paymentDetails.emailAddress = this.customerDetailsList.customerDetails.emailId;
    this.inputForPayment.paymentDetails.firstName = this.customerDetailsList.customerDetails.nameOfCorporate;
    this.inputForPayment.paymentDetails.phoneNumber = this.customerDetailsList.customerDetails.mobileNumber.toString();
    this.inputForPayment.paymentDetails.proposalNo = localStorage.getItem('ProposalNumber');
    this.inputForPayment.paymentDetails.productInfo = this.customerDetailsList.product;
    this.paymentService.getTransactionId().subscribe(
      (res) => {
        this.inputForPayment.paymentDetails.transactionId = res.toString();
        this.createQuoteService.makePayment(this.inputForPayment).subscribe(
          (res) => {
            const myWindow = window.open('', '_self');
            myWindow.document.write(res);
          },
          (error: HttpErrorResponse) => {
          }
        );
      },
      (error: HttpErrorResponse) => {
      }
    );
  }

  convertNumberToINR(numToInr) {
    return this.commonMethodService.formatNumberToINR(numToInr);
  }


  rejectProposalButton() {
    this.isCustomerRejectionCommentsInvalid = false;
  }

  clearSearchText() {
    this.searchText = '';
  }
  rejectProposal() {

    if (this.customerProposalTotalResponse.status == 'Rejected by Customer') {
      this.ifProposalRejected = true;
    } else {
      if (this.customerRejectCommentsDetails.comment == '') {
        this.isCustomerRejectionCommentsInvalid = true;
        return;
      }

      this.rejectCustomerProposal.customerName = this.customerDetailsList.customerDetails.nameOfCorporate;
      this.rejectCustomerProposal.customerLastName = this.customerDetailsList.customerDetails.nameOfCorporate;
      this.rejectCustomerProposal.proposalNo = this.customerProposalTotalResponse.proposalNumber;
      if (this.customerDetailsList.intermediaryDetails.salutation == '') {
        this.rejectCustomerProposal.salutation = 'MR';
      } else {
        this.rejectCustomerProposal.salutation = this.customerDetailsList.intermediaryDetails.salutation;
      }
      this.rejectCustomerProposal.partnerMobileNumber = this.customerDetailsList.intermediaryDetails.mobileNumber;
      this.rejectCustomerProposal.productName = this.customerDetailsList.product;
      this.rejectCustomerProposal.productId = this.customerDetailsList.ProductCode;
      this.rejectCustomerProposal.status = 'Rejected by Customer';
      this.rejectCustomerProposal.intermediaryID = this.customerDetailsList.intermediaryDetails.IntermediaryID;
      this.rejectCustomerProposal.partnerLastName = this.customerDetailsList.intermediaryDetails.firstName;
      this.rejectCustomerProposal.partnerEmail = this.customerDetailsList.intermediaryDetails.emailId;
      this.customerRejectCommentsDetails.createdBy = this.rejectCustomerProposal.customerName;
      this.customerRejectCommentsDetails.userCode = this.customerDetailsList.customerDetails.customerID;
      this.rejectCustomerProposal.endorsmentNumber = this.customerProposalTotalResponse.endorsmentNumber;
      this.rejectCustomerProposal.modeofOperation = this.customerDetailsList.ModeOfOperation;

      this.customerRejectCommentsDetails.time = formatDate(new Date(), 'dd/MM/yyyy h:mm:ss a', 'en-us');
      this.rejectCustomerProposal.custCommentsDetails.push(this.customerRejectCommentsDetails);

      this.commonService.rejectCustomerProposalMarineStop(this.rejectCustomerProposal).subscribe(success => {
        this.ifProposalRejected = true;
        $('#RejectProposal').modal('hide');
      },
        error => {
        }
      );
    }
  }

  saveEditCustomerProposal(editForm) {
    //console.log("editeddata=", editForm.value);
    this.customerProposalEditParams.ProposalNumber = this.customerProposalTotalResponse.proposalNumber;
    this.customerProposalService.saveMarineStopEditCustomerProposalDetails(this.customerProposalEditParams)
      .subscribe(
        res => {
          this.isEditCustomerProposal = false;
          this.isCheckSelected = false;
          this.customerProposalService.getMarineOpenCustomerProposalDetails(this.tempProposalNumber).subscribe((res: any) => {
            this.customerDetailsList = res.inputRequest;
            //console.log("ccdd=", this.customerDetailsList);
            this.customerProposalTotalResponse = res;
            this.customerDetailsList.riskDetails.voyageExpectedDate = this.datepipe.transform(
              this.customerDetailsList.riskDetails.voyageExpectedDate,
              'dd/MM/yyyy'
            );
            if (this.isEndorsement) {
              this.notifyService.showSuccess('Endorsement ' + this.customerProposalEditParams.endorsementNumber + ' ' + 'saved successfully', 'Endorsement Notification');
            } else {
              this.notifyService.showSuccess('Customer Profile updated successfully', 'Customer Profile Notification');
            }
          }
          );
          setTimeout(() => {
            this.tooltipInit();
          }, 1000);

          setTimeout(() => {
            this.tooltipInit();
          }, 4000);
        }
      );
  }

  customerTypeMapping() {
    if (this.customerProposalEditParams.customerDetails['customerType'] == 'I') {
      this.customerProposalEditParams.customerDetails['customerType'] = 'Individual';
    } else if (this.customerProposalEditParams.customerDetails['customerType'] == 'C') {
      this.customerProposalEditParams.customerDetails['customerType'] = 'Corporate';
    } else if (this.customerProposalEditParams.customerDetails['customerType'] == 'G') {
      this.customerProposalEditParams.customerDetails['customerType'] = 'Govt Undertaking';
    }
  }

  valuationCategoryDuplicate(event, riskIndex, bovi) {
    const alreadyValuationCategoryExist = this.customerProposalEditParams.riskDetails[riskIndex].bovDetails.filter(bovDetail => bovDetail.valuationCategory === event);
    if (alreadyValuationCategoryExist.length > 0) {
      this.customerProposalEditParams.riskDetails[riskIndex].bovDetails[bovi].alreadyValuationCategoryExist = true;
    } else {
      this.customerProposalEditParams.riskDetails[riskIndex].bovDetails[bovi].alreadyValuationCategoryExist = false;

    }
  }
  valuationCategoryBov(event, riskIndex, bovi) {
    if (event === '') {
      this.customerProposalEditParams.riskDetails[riskIndex].bovDetails[bovi].bovPercentage = null;
    } else {
      const valuationCategory = this.masterDataForMO.VALUATION_CATEGORY.filter(valCategory => valCategory.lookupValue === event);
      if (this.customerProposalEditParams.riskDetails[riskIndex].bovDetails[bovi].bovPercentage > valuationCategory[0].gcLongDesc) {
        this.customerProposalEditParams.riskDetails[riskIndex].bovDetails[bovi].showBovPercentageValidation = true;
      } else {
        this.customerProposalEditParams.riskDetails[riskIndex].bovDetails[bovi].showBovPercentageValidation = false;

      }

    }
  }

  formatdocName(docName) {
    return docName.replace(/_/g, ' ');
  }

  getToday(): string {
    return new Date().toISOString().split('T')[0];
  }

  focusoutFunction() {
    this.mobileSpace = false;
  }
  // mousenumClick() {
  //   if (this.wcProposalModel.customerDetails.mobileNumber != '' && this.wcProposalModel.customerDetails.mobileNumber != null) {
  //     this.mobileSpace = false;
  //   }
  //   else {
  //     this.mobileSpace = true;
  //   }
  // }

  onKeyUpValidationForField(fieldName) {
    switch (fieldName) {
      case 'dob':
        if ((new Date().getFullYear() - new Date(this.DateofBirthEditProposal).getFullYear()) < 18) {
          this.isDobInvalid = true;
        } else {
          this.isDobInvalid = false;
        }
        break;
      case 'dobFuture':
        if (
          (new Date(this.DateofBirthEditProposal)) > (new Date(this.getToday()))
        ) {
          this.dobFutureDate = true;
        } else {
          this.dobFutureDate = false;
        }
        break;
      case 'policyDate':
        if ((new Date(this.policyStartDate)) < (new Date(this.getToday()))
        ) {
          this.isPolicyStartDate = true;
        } else {
          this.isPolicyStartDate = false;
        }
        break;
      case 'emailId':
        const pattern = /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9]+\.([a-zA-Z]{2,5}|[a-zA-z]{2,5}\.[a-zA-Z]{2,5})/;
        const inputString = this.customerProposalEditParams.InputXML['customerDetails']['emailId'];
        if (pattern.test(inputString)) {
          this.isEmailIdInValid = false;
        } else {
          this.isEmailIdInValid = true;
        }
        break;
      case 'alternateEmailId':
        const patternAl = /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9]+\.([a-zA-Z]{2,5}|[a-zA-z]{2,5}\.[a-zA-Z]{2,5})/;
        const inputStringAl = this.customerProposalEditParams.InputXML['customerDetails']['alternateEmailId'];
        if (patternAl.test(inputStringAl)) {
          this.isAlEmailIdInValid = false;
        } else {
          this.isAlEmailIdInValid = true;
        }
        break;
      case 'mobileNumber1':
        const patternmb1 = /^[6-9.][0-9]{9}$/;
        const inputStringmb1 = this.customerProposalEditParams.InputXML['customerDetails']['mobileNumber'];
        if (patternmb1.test(inputStringmb1)) {
          this.isMobilenumberInValid = false;
        } else {
          this.isMobilenumberInValid = true;
        }
        break;
      case 'mobileNumber2':
        const patternmb2 = /^[6-9.][0-9]{9}$/;
        const inputStringmb2 = this.customerProposalEditParams.InputXML['customerDetails']['alternateMobileNumber'];
        if (patternmb2.test(inputStringmb2)) {
          this.isMobilenumber2InValid = false;
        } else {
          this.isMobilenumber2InValid = true;
        }
        break;
      default:
        break;
    }
  }

  keyPressAlphaNumeric(event) {
    var inp = String.fromCharCode(event.keyCode);
    if (/[a-zA-Z0-9]/.test(inp)) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }
  removeBasisOfValuation(riskIndex, boviIndex) {
    if (this.customerProposalEditParams.riskDetails[riskIndex].bovDetails.length > 1) {
      this.customerProposalEditParams.riskDetails[riskIndex].bovDetails.splice(boviIndex, 1);
    }
  }
  addAnotherBOVDetail(riskIndex) {
    this.customerProposalEditParams.riskDetails[riskIndex].bovDetails.push(new BasisOfValuation('', null, '', false, false));
  }
  validatePerLocationLimitCheck(event, index, field) {
    this.perLocationValid[index] = false;
    if (field === 'perSending' && event > parseInt(this.customerProposalEditParams.riskDetails[index].voyageDetails.perLocationLimit)) {
      this.perLocationValid[index] = true;
    } if (field === 'perLocation' && event < parseInt(this.customerProposalEditParams.riskDetails[index].voyageDetails.perSendingLimit)) {
      this.perLocationValid[index] = true;
    }
  }

}
